export default __webpack_public_path__ + "static/media/down-arrow-selector-quickship.88b218b8.svg";